import React, { useEffect, useState } from "react";
import HeaderRoutes from "../../components/HeaderRoutes/HeaderRoutes";
import { Grid, Box, Paper, Typography, Button, TextField, CircularProgress, InputAdornment, IconButton } from "@mui/material";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useTheme, styled } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import OutlinedInput from '@mui/material/OutlinedInput';
import axios from 'axios';
import config from '../../config/config';
import Toast from '../../config/Toast';
import { DataGrid } from '@mui/x-data-grid';
import Multiselect from 'multiselect-react-dropdown';
import moment from "moment";
import SearchIcon from "@mui/icons-material/Search";
import VisibilityIcon from '@mui/icons-material/Visibility';
import Modal from 'react-bootstrap/Modal';
import { Row, Col } from "react-bootstrap";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const CreateVariables = () => {
    const theme = useTheme();
    const [loading, setLoading] = useState(false)
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [message, setMessage] = useState('');
    const [type, setType] = useState('');
    const [variableName, setVariableName] = useState('')
    const [variableValue, setVariableValue] = useState('false')
    const [variableList, setVariableList] = useState([])
    const [desc, setDesc] = useState("")
    const [searchResult, setSearchResult] = useState("")
    const [editModal, setEditModal] = useState(false)
    const [description, setDescription] = useState([])
    const [descModal, setDescModal] = useState(false)
    const [editId, setEditId] = useState("")
    const [deleteModal, setDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState("")

    const VariableList = async (loader = true) => {
        const data = {
            search: searchResult,
        };

        if (loader) {
            setLoading(true)
        }

        const path = `${config.authServiceUrl}variables/list`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.post(path, data, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setLoading(false)
            setVariableList(response?.data?.data)
        } catch (error) {
            setLoading(false)
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    useEffect(() => {
        VariableList()
    }, [])

    useEffect(() => {
        VariableList(false)
    }, [searchResult])

    const loadData = async (id, type) => {
        const path = `${config.authServiceUrl}variables/${id}`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.get(path, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            if (type == 'view') {
                setDescModal(true)
            } else {
                setEditModal(true)
            }
            setDescription(response?.data?.data)
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const deleteData = async () => {
        const path = `${config.authServiceUrl}variables/delete/${deleteId}`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.get(path, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            VariableList()
            setDeleteModal(false)
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const handleCreate = async () => {
        const data = {
            variable_name: variableName,
            variable_default: variableValue,
            description: desc
        };

        const path = `${config.authServiceUrl}variables/create`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.post(path, data, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setSnackbarOpen(true);
            setMessage(response?.data?.data);
            setType('success');
            setVariableName('')
            setDesc('')
            await VariableList();
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const editDesc = async () => {
        const data = {
            variable_id: editId,
            description: description
        };

        const path = `${config.authServiceUrl}variables/add-desc`;
        const token = localStorage.getItem("tokenId");

        try {
            const response = await axios.post(path, data, {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
            setMessage(response?.data?.message);
            setType('success');
            setSnackbarOpen(true);
            setEditModal(false)
            setSearchResult('')
            VariableList()
        } catch (error) {
            const apiError = error.response?.data?.message || "An error occurred.";
            setMessage(apiError);
            setType('error');
            setSnackbarOpen(true);
        }
    };

    const handleCloseSnackbar = () => {
        setSnackbarOpen(false);
    };

    const columns = [
        { field: 'id', headerName: 'ID' },
        { field: 'variable_name', headerName: 'Variable Name', flex: 1 },
        {
            field: 'Description', headerName: 'Description', flex: 1,
            renderCell: (params) => {
                return (
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        {/* <img src="/images/edit-icon.svg" style={{ width: '20px', cursor: 'pointer' }}
                            onClick={() => {
                                loadData(params?.row?.id, 'edit')
                                setEditId(params?.row?.id)
                            }}
                        /> */}
                        <IconButton color="secondary">
                            <EditIcon fontSize="small"
                                onClick={() => {
                                    loadData(params?.row?.id, 'edit')
                                    setEditId(params?.row?.id)
                                }}
                            />
                        </IconButton>

                        <IconButton color="secondary">
                            <VisibilityIcon fontSize="small"
                                onClick={() => {
                                    loadData(params?.row?.id, 'view')
                                }}
                            />
                        </IconButton>

                        <IconButton color="secondary">
                            <DeleteIcon fontSize="small"
                                onClick={() => {
                                    setDeleteModal(true)
                                    setDeleteId(params?.row?.id)
                                }}
                            />
                        </IconButton>
                    </Box>
                );
            },
        },
        { field: 'variable_default', headerName: 'Default Value', flex: 1 },
        {
            field: 'created_at', headerName: 'Created At', flex: 1,
            renderCell: (params) =>
                moment(params.value).format('MM/DD/YYYY ,  HH:mm:ss'),
        },
        {
            field: 'updated_at', headerName: 'Updated At', flex: 1,
            renderCell: (params) =>
                moment(params.value).format('MM/DD/YYYY ,  HH:mm:ss'),
        },
    ];


    return (
        <>
            <HeaderRoutes />
            <Paper sx={{ height: 'fit-content', margin: isMobile ? '16px' : '16px', padding: '20px' }}>
                <Typography
                    style={{
                        fontFamily: 'Karla',
                        fontStyle: 'normal',
                        fontSize: '20px',
                        lineHeight: '150%',
                        color: '#000000',
                        fontWeight: 500,
                    }}
                >
                    Create New Variable
                </Typography>

                <Box className='mt-5 px-3'>
                    <Grid container spacing={2}>
                        <Grid xs={6}>
                            <TextField
                                fullWidth
                                placeholder="Enter Variable Name"
                                label="Variable Name"
                                type='text'
                                value={variableName}
                                onChange={(e) => setVariableName(e.target.value)}
                            />
                        </Grid>

                        <Grid xs={6}>
                            <TextField
                                fullWidth
                                placeholder="Enter Variable Value"
                                label="Variable value"
                                type='text'
                                className="mx-2"
                                value={variableValue}
                                onChange={(e) => setVariableValue(e.target.value)}
                            />
                        </Grid>

                        <Grid xs={6}>
                            <TextField
                                fullWidth
                                placeholder="Enter Description"
                                label="Description"
                                type='text'
                                className="mt-3"
                                value={desc}
                                onChange={(e) => setDesc(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                </Box>

                <Box className='mt-4'>
                    <Button
                        variant="contained"
                        color="primary"
                        disabled={!variableName || !variableValue}
                        sx={{ backgroundColor: '#BF1D2D', fontSize: '16px', fontWeight: '500', padding: '20px', height: '38px' }}
                        onClick={handleCreate}
                    >
                        Submit
                    </Button>
                </Box>
            </Paper>

            {loading && (
                <Box sx={{ display: 'flex', justifyContent: 'center', marginTop: '20%' }}>
                    <CircularProgress />
                </Box>
            )}

            {!loading &&
                <Paper sx={{ margin: isMobile ? '16px' : '16px', padding: '20px' }}>
                    <Box>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    style={{
                                        fontFamily: 'Karla',
                                        fontStyle: 'normal',
                                        fontSize: '22px',
                                        lineHeight: '150%',
                                        color: '#000000',
                                        fontWeight: 500,
                                    }}
                                >
                                    List of Variables
                                </Typography>
                            </div>
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <TextField
                                    variant="outlined"
                                    placeholder="Search"
                                    onChange={(e) => setSearchResult(e.target.value)}
                                    className="w-100"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    <SearchIcon />
                                                </IconButton>
                                            </InputAdornment>
                                        ),
                                        sx: {
                                            height: '48px',
                                            fontSize: '14px',
                                            marginRight: '10px',
                                        },
                                    }}
                                />
                            </div>
                        </div>
                        <Box sx={{ mt: 1 }}>
                            {variableList.length == 0 ? (
                                <Typography>No Variable found.</Typography>
                            ) : (
                                <DataGrid
                                    rows={variableList}
                                    columns={columns}
                                    pagination
                                    disableSelectionOnClick
                                />
                            )}
                        </Box>
                    </Box>
                </Paper>
            }

            <Toast
                snackbarOpen={snackbarOpen}
                handleCloseSnackbar={handleCloseSnackbar}
                message={message}
                type={type}
            />

            {/* Edit Modal */}
            <Modal show={editModal} size="md"
                onHide={() => { setEditModal(false) }}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Description</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row className='w-100 m-auto' style={{ flexWrap: 'wrap' }}>
                        <Col md={12} className="p-0">
                            <TextField
                                className='mt-1 w-100'
                                multiline
                                color='secondary'
                                variant="outlined"
                                value={description.description}
                                placeholder="Enter Description"
                                sx={{
                                    "& .MuiInputBase-input": {
                                        // position: 'absolute',
                                        // top: '13px',
                                        // left: '12px',
                                        minHeight: '150px',
                                        maxHeight: '150px',
                                        overflow: 'scroll !important',
                                        scrollbarWidth: 'none'
                                    }
                                }}
                                onChange={(e) => setDescription(e.target.value)}
                            />
                        </Col>
                    </Row>
                    <ButtonTheme type='submit' variant="filled" color='primary' className='mt-3'
                        onClick={() => editDesc()}
                    >
                        Submit
                    </ButtonTheme>
                </Modal.Body>
            </Modal>


            {/* Description Modal */}
            <Modal show={descModal} size="md"
                onHide={() => {
                    setDescModal(false)
                    setDescription([])
                }}>

                <Modal.Header closeButton>
                    <Modal.Title>Variable Description</Modal.Title>
                </Modal.Header>

                <Modal.Body style={{ padding: 22 }}>
                    <Grid item xs={12} sm={6} md={6}>

                        <div className='font-fam model-bg'>
                            <div className='row' style={{ paddingLeft: '10px' }}>
                                <div>
                                    <span style={{ color: '#000', marginLeft: '-10px' }}>
                                        {description?.description || "No Description"}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Grid>
                </Modal.Body>
            </Modal>

            {/* Delete Modal */}
            <Modal show={deleteModal} onHide={() => setDeleteModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Delete Variable</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div style={{ color: '#555555' }}>
                        Are you sure you want to delete this Variable?
                    </div>
                    <Row>
                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                setDeleteModal(false)
                            }}>
                                Cancel
                            </ButtonTheme>
                        </Col>

                        <Col md='auto'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4'
                                onClick={() => deleteData()}
                            >
                                Delete
                            </ButtonTheme>
                        </Col>
                    </Row>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default CreateVariables;